var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1383 10.4456C21.6619 10.4456 21.2767 10.8537 21.2767 11.3584V19.6698C21.2767 19.847 20.9118 20.1718 20.3137 20.1718H3.68633C3.09077 20.1718 2.7233 19.847 2.7233 19.6698V10.9128C2.7233 10.4081 2.33809 10 1.86165 10C1.38521 10 1 10.4081 1 10.9128V19.6725C1 20.3383 1.32439 20.9718 1.88699 21.4094C2.37864 21.7906 3.01728 22 3.68633 22H20.3137C20.9827 22 21.6214 21.7906 22.113 21.4094C22.6756 20.9718 23 20.3383 23 19.6725V11.3584C23 10.8564 22.6123 10.4456 22.1383 10.4456Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.234 16.2885C10.6973 16.7443 11.3142 16.9975 11.9727 17H11.9857C12.639 17 13.2558 16.7544 13.7191 16.3062L17.7378 12.4372C18.0839 12.103 18.0891 11.5586 17.743 11.2193C17.3994 10.8825 16.8398 10.8774 16.491 11.2142L12.8602 14.711C12.8758 14.6452 12.8862 14.5768 12.8862 14.5059V2.8609C12.8862 2.38488 12.4906 2 12.0013 2C11.512 2 11.1164 2.38488 11.1164 2.8609V14.5059C11.1164 14.5869 11.1294 14.6654 11.1502 14.7414L7.51416 11.1661C7.1706 10.8293 6.61101 10.8243 6.26224 11.161C5.91608 11.4953 5.91087 12.0397 6.25704 12.379L10.234 16.2885Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7b02c88e82f31e5fa6273de04ecc98c4.svg";
export { ForwardRef as ReactComponent };